"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeMatchesType = exports.valueMatchesType = void 0;
var type_1 = require("./type");
var utils_1 = require("./utils");
var util_1 = require("../evaluator/util");
/**
 * Checks if the given value matches the given type.
 */
function valueMatchesType(value, type) {
    if (typeof type === "string") {
        switch (type) {
            case type_1.VoidType:
                return false;
            case type_1.AnyType:
                return true;
            case type_1.AnyArrayType:
                return util_1.isArrayValue(value);
        }
    }
    else if (utils_1.isNumberType(type)) {
        return util_1.isNumberValue(value) && (type.value === undefined || value.value === type.value);
    }
    else if (utils_1.isStringType(type)) {
        return util_1.isStringValue(value) && (type.value === undefined || value.value === type.value);
    }
    else if (utils_1.isBooleanType(type)) {
        return util_1.isBooleanValue(value) && (type.value === undefined || value.value === type.value);
    }
    else if (utils_1.isUnionType(type)) {
        return type.options.some(function (option) {
            return valueMatchesType(value, option);
        });
    }
    else if (typeof type === "object" && type["type"] === type_1.AnyArrayType && type.elements) {
        if (!util_1.isArrayValue(value)) {
            return false;
        }
        if (type.elements === type_1.VoidType) {
            return value.elements.length === 0;
        }
        else {
            // .every returns true for empty arrays, empty array fits arrays of any type
            return value.elements.every(function (elem) {
                return valueMatchesType(elem, type.elements);
            });
        }
    }
    throw new Error("Unexpected type '" + JSON.stringify(type) + "'");
}
exports.valueMatchesType = valueMatchesType;
/**
 * Checks if the candidate type matches the given candidate type matches another type
 *
 * @param candidate The candidate type
 * @param type The type that the candidate type may be equal to
 * @param requireValueEquality Determines if primitive types with differing values are considered equal or not.
 */
function typeMatchesType(candidate, type, requireValueEquality) {
    if (requireValueEquality === void 0) { requireValueEquality = true; }
    if (typeof type === "string") {
        switch (type) {
            case type_1.VoidType:
                return false;
            case type_1.AnyType:
                return true;
            case type_1.AnyArrayType:
                return utils_1.isArrayType(candidate);
        }
    }
    else if (utils_1.isNumberType(type)) {
        return utils_1.isNumberType(candidate) && (!requireValueEquality || type.value === undefined || candidate.value === type.value);
    }
    else if (utils_1.isStringType(type)) {
        return utils_1.isStringType(candidate) && (!requireValueEquality || type.value === undefined || candidate.value === type.value);
    }
    else if (utils_1.isBooleanType(type)) {
        return utils_1.isBooleanType(candidate) && (!requireValueEquality || type.value === undefined || candidate.value === type.value);
    }
    else if (utils_1.isUnionType(type)) {
        if (utils_1.isUnionType(candidate)) {
            return utils_1.areUnionsCompatible(candidate, type);
        }
        else {
            return type.options.some(function (option) {
                return typeMatchesType(candidate, option, requireValueEquality);
            });
        }
    }
    else if (typeof type === "object" && type["type"] === type_1.AnyArrayType && type.elements) {
        if (!utils_1.isArrayType(candidate)) {
            return false;
        }
        return typeMatchesType(candidate.elements, type.elements, requireValueEquality);
    }
    throw new Error("Unexpected type '" + JSON.stringify(type) + "'");
}
exports.typeMatchesType = typeMatchesType;
//# sourceMappingURL=checker.js.map